import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { useEffect, useState } from 'react';
type SplitDisplayProps = {
  isReady?: boolean;
  showLeftContent: boolean;
  leftContent: React.ReactNode | null;
  showRightContent: boolean;
  rightContent: React.ReactNode | null;
};
export const SplitDisplay = t0 => {
  const $ = _c(18);
  const {
    isReady: t1,
    showLeftContent,
    leftContent,
    showRightContent,
    rightContent
  } = t0;
  const isReady = t1 === undefined ? true : t1;
  const showLeftPanel = showLeftContent && !!leftContent;
  const showRightPanel = showRightContent && !!rightContent;
  const [hasSettled, setHasSettled] = useState(false);
  let t2;
  let t3;
  if ($[0] !== hasSettled || $[1] !== isReady) {
    t2 = () => {
      if (!isReady || hasSettled) {
        return;
      }
      const id = setTimeout(() => setHasSettled(true), 100);
      return () => clearTimeout(id);
    };
    t3 = [isReady, hasSettled];
    $[0] = hasSettled;
    $[1] = isReady;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  let t6;
  if ($[4] !== hasSettled || $[5] !== leftContent || $[6] !== showLeftPanel || $[7] !== showRightPanel) {
    let t7;
    bb0: {
      if (showLeftPanel && showRightPanel) {
        t7 = {
          leftPanelWidth: "w-2/3",
          rightPanelWidth: "w-1/3"
        };
        break bb0;
      }
      if (showRightPanel) {
        t7 = {
          leftPanelWidth: "w-0",
          rightPanelWidth: "w-full"
        };
        break bb0;
      }
      t7 = {
        leftPanelWidth: "w-full",
        rightPanelWidth: "w-0"
      };
    }
    const {
      leftPanelWidth,
      rightPanelWidth
    } = t7;
    const transition = hasSettled ? "transition-all duration-500 ease-in-out" : "";
    t5 = "absolute inset-0 flex overflow-hidden animate-fade-in";
    t6 = <div className={cx("flex flex-col shrink-0 overflow-y-auto", transition, leftPanelWidth)}>{leftContent}</div>;
    t4 = cx("flex flex-col shrink-0 overflow-hidden min-w-[33.333%]", transition, rightPanelWidth);
    $[4] = hasSettled;
    $[5] = leftContent;
    $[6] = showLeftPanel;
    $[7] = showRightPanel;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[11] !== rightContent || $[12] !== t4) {
    t7 = <div className={t4}>{rightContent}</div>;
    $[11] = rightContent;
    $[12] = t4;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};